/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';
import Collection from 'fierry/data/collection';

import Account from 'solis/data/account';
import Colony from 'solis/data/colony/colony';
import Board from 'solis/data/board/board';



export default class Galaxy extends Entity
{
  static children = [ 'accounts', 'colonies', 'boards', 'scores' ];


  loadAccount (cass)
  {
    return this.loadWithSettings(this.getAccounts().load(cass.id, cass));
  }


  loadBoard (cass)
  {
    return this.loadWithSettings(this.getBoards().load(cass.id, cass));
  }


  loadColony (cass)
  {
    return this.loadWithSettings(this.getColonies().load(cass.id, cass));
  }


  loadWithSettings (entity)
  {
    entity.loadSettings(this.parent.getSettings());

    return entity;
  }


  loadCurrentAccount (id)
  {
    this.cursor.child('currentAccount').set(id);
  }


  loadScore (cass)
  {
    return this.getScores().load(cass.id, cass);
  }


  unloadAccount (cass)
  {
    this.getAccounts().unload(cass.id);
  }


  unloadBoard (cass)
  {
    this.getBoards().unload(cass.id);
  }


  unloadColony (cass)
  {
    this.getColonies().unload(cass.id);
  }


  unloadCurrentAccount ()
  {
    this.cursor.child('currentAccount').remove();
  }


  unloadScore (cass)
  {
    this.getScores().unload(cass.id);
  }


  createAccount (id)
  {
    const cass = {};

    cass.galaxy = this.cass.id;

    cass.id = id;

    cass.active = true;
    cass.anonymous = false;

    cass.colonyCounter = 0;

    const settings = this.parent.getSettings();

    cass.gravityResource = { value: settings.getGravityResource().initial, date: Date.now() };
    cass.retryResource = { value: settings.getRetryResource().initial, date: Date.now() };

    return this.loadAccount(cass);
  }


  createBoard (id)
  {
    const cass = {};

    cass.galaxy = this.cass.id;

    cass.id = id;

    cass.createDate = Date.now();
    cass.updateDate = Date.now();

    return this.loadBoard(cass);
  }


  createColony (id, user)
  {
    const cass = {};

    cass.galaxy = this.cass.id;

    cass.id = id;
    cass.user = user;

    cass.board = null;

    cass.authority = 0;

    return this.loadColony(cass);
  }


  createScore (id)
  {
    const cass = {};

    cass.galaxy = this.cass.id;

    cass.id = id;

    cass.territory = 0;
    cass.authority = 0;
    cass.value = 0;

    return this.loadScore(cass);
  }


  getAccount (id)
  {
    return this.getAccounts().at(id);
  }


  getAccounts ()
  {
    return new Collection(Account, this.cursor.child('accounts'));
  }


  getBoard (id)
  {
    return this.getBoards().at(id);
  }


  getBoards ()
  {
    return new Collection(Board, this.cursor.child('boards'));
  }


  getColony (id)
  {
    return this.getColonies().at(id);
  }


  getColonies ()
  {
    return new Collection(Colony, this.cursor.child('colonies'));
  }


  getCurrentAccount ()
  {
    return this.getAccount(this.cursor.child('currentAccount').get());
  }


  getScore (id)
  {
    return this.getScores().at(id);
  }


  getScores ()
  {
    return new Collection(Entity, this.cursor.child('scores'));
  }


  getState ()
  {
    return this.cursor.get();
  }


};
